import { useSelector } from 'react-redux';
import { ILineResource } from '../../../entities/farms.entities';
import { translate } from '../../../lib/lang.helper';
import { CheckboxButton, Dropdown } from '../../shared';
import { selectLang } from '../../../store/ui/ui.selector';
import { defaultDateFormat } from '../../../lib/common.helpers';

interface IForm {
  batch_seed_id?: number | null;
  origin_spat_id?: number | null;
}

interface Props {
  status: boolean;
  onChange: (status: boolean) => void;
  lineData: ILineResource;
  form?: IForm;
  onBatchSelect: (f: IForm | null) => void;
}

const BatchAssessView = ({
  status,
  onChange,
  lineData,
  form,
  onBatchSelect,
}: Props) => {
  const lang = useSelector(selectLang);

  const toggleCheck = (c: boolean) => {
    onChange(c);
    if (!c) onBatchSelect(null);
  };

  const spatsOptions = lineData?.growing_cycle?.seedings
    .filter(x => !!x.spat_source_id)
    .map(x => ({
      id: x.spat_source_id?.toString() as string,
      value: x.spat_source_id?.toString() as string,
      label: `${defaultDateFormat(x.planned_date_seed)}, ${translate(
        lang,
        'Batch',
      )} ${x.spat_source}`,
      batch_seed_id: x.id,
    }));

  const changeOption = (spatId: string) => {
    const spat = spatsOptions?.find(o => o.id === spatId);
    if (spat) {
      onBatchSelect({
        origin_spat_id: Number(spatId),
        batch_seed_id: spat.batch_seed_id,
      });
    }
  };

  return (
    <div className='mb-32 mt-24'>
      <CheckboxButton
        label={translate(lang, 'Batch assessed')}
        checked={status}
        onChange={e => toggleCheck(e.target.checked)}
      />
      {status && !!spatsOptions && (
        <Dropdown
          label={translate(lang, '_assessed_original_spat')}
          options={spatsOptions ?? []}
          value={form?.origin_spat_id?.toString() ?? undefined}
          onChange={v => changeOption(v)}
        />
      )}
    </div>
  );
};

export default BatchAssessView;
